<template>
  <b-card class="mb-0">
    <template v-slot:header>
      <div class="d-flex">
        <slot name="header">
          <div class="no-print d-flex flex-column mt-1">
            <div class="no-print d-flex flex-row m-0 mr-2">  
              <button-refresh size="sm" style="border-radius: 4px 0px 0px 4px;" :animate="animateRefresh" :disabled="isBusy || isBusyInner" class="align-self-start" @click="autoUpdateSec = refreshSec == 0 ? 0 : autoUpdateSec; $emit('onRefresh')"/>
              <b-input size="sm" style="border-radius: 0px 4px 4px 0px; width: 60px;" :disabled="false" type="number" min="0" max="300" step="30" v-model="autoUpdateSec"></b-input>
            </div>
            <b-progress class="mr-2" height="5px" :value="progressValue" :max="autoUpdateSec"></b-progress>
          </div>

          <h4 v-if="title" class="card-title m-0 mr-2 mt-1">{{title}}</h4>
          <b-nav tabs class="mt-2">
            <b-nav-item 
              v-for="page in pages" 
              :key="page.id" 
              :active="selectedPage==page.id" 
              @click="selectedPage=page.id"
            >
              {{ page.value }}
            </b-nav-item>
          </b-nav>
        </slot>

        <div class="no-print d-flex mb-2">
          <slot name="filter"></slot>
        </div>
        
        <div class="d-flex ml-auto mt-1 mb-2">
          <slot name="header-actions" class="no-print">
            
          </slot>
        </div>
      </div>
    </template>

    <!--<b-progress height="5px" :value="progressValue" :max="autoUpdateSec"></b-progress>-->
    <slot ></slot>
  </b-card>
</template>

<script>

export default {
  name: 'base-table-tab-page-card',
  inheritAttrs: false,
  components: { },

  props: {
    value: {},

    refreshSec: {
      type: Number,
      default: 0
    },

    title: {
      type: String,
      default: null
    },

    pages: {
      type: [Array, Function],
      default: () => []
    },

    isBusy: {
      type: Boolean,
      default: false
    },
  },

  data: () => {
    return {
      animateRefresh: false,
      progressValue: 0,
      autoUpdateSec: 0,
      timerCounter: 0,
      timerId: null,

      isBusyInner: false,
      
    }
  },

  computed: {
    selectedPage: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
  },

  watch: {
    refreshSec() {
      this.autoUpdateSec = this.refreshSec
    },

    autoUpdateSec() {
      if (this.autoUpdateSec > 0 && this.autoUpdateSec < 30) {
        this.autoUpdateSec = 30
      }
      if (this.autoUpdateSec > 0) {        
        this.startTimer()
      }
      else {
        this.stopTimer();
      }
    }
  },

  methods: {
    startTimer() {
      
      this.progressValue = 0
      this.timerCounter = 0
      this.stopTimer()

      let self = this
      this.timerId = setTimeout(function tick() 
        { 
          self.progressValue++

          self.timerCounter++
          if (self.timerCounter > self.autoUpdateSec){
            self.progressValue = 0
            self.timerCounter = 0
            self.$emit('onRefresh')
          }
          
          self.timerId = setTimeout(tick, 1000);
        }, 
        100
      );
    },

    stopTimer() {      
      clearTimeout(this.timerId)
      this.progressValue = 0
    }
  },

  mounted() {
    this.autoUpdateSec = this.refreshSec
  }
}

</script>
